"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return MapView;
    }
});
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _MapViewColumn = /*#__PURE__*/ _interop_require_default(require("~/models/MapViewColumn"));
const _extractProps = require("~/helpers/extractProps");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _modelUtils = require("~/utils/modelUtils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let MapView = class MapView {
    static async get(context, viewId, ncMeta = _Noco.default.ncMeta) {
        let view = viewId && await _NocoCache.default.get(context, `${_globals.CacheScope.MAP_VIEW}:${viewId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!view) {
            view = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.MAP_VIEW, {
                fk_view_id: viewId
            });
            await _NocoCache.default.set(context, `${_globals.CacheScope.MAP_VIEW}:${viewId}`, view);
        }
        return view && new MapView(view);
    }
    static async insert(context, view, ncMeta = _Noco.default.ncMeta) {
        const insertObj = {
            base_id: view.base_id,
            source_id: view.source_id,
            fk_view_id: view.fk_view_id,
            fk_geo_data_col_id: view.fk_geo_data_col_id,
            meta: view.meta
        };
        const viewRef = await _View.default.get(context, insertObj.fk_view_id, ncMeta);
        if (!insertObj.source_id) {
            insertObj.source_id = viewRef.source_id;
        }
        await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.MAP_VIEW, insertObj, true);
        return this.get(context, view.fk_view_id, ncMeta);
    }
    static async update(context, mapId, body, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(body, [
            'fk_geo_data_col_id',
            'meta'
        ]);
        if (body.fk_geo_data_col_id != null) {
            const mapViewColumns = await _MapViewColumn.default.list(context, mapId);
            const mapViewMappedByColumn = mapViewColumns.find((mapViewColumn)=>mapViewColumn.fk_column_id === body.fk_geo_data_col_id);
            await _View.default.updateColumn(context, body.fk_view_id, mapViewMappedByColumn.id, {
                show: true
            });
        }
        // update meta
        const res = await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.MAP_VIEW, (0, _modelUtils.prepareForDb)(updateObj), {
            fk_view_id: mapId
        });
        await _NocoCache.default.update(context, `${_globals.CacheScope.MAP_VIEW}:${mapId}`, (0, _modelUtils.prepareForResponse)(updateObj));
        return res;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
